import { NumberInput, NumberInputProps } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'

type PhoneNumberValues = {
  phoneNumber?: string | null
  countryCode?: number | null
}

interface Props<Values extends PhoneNumberValues> {
  form: UseFormReturnType<Values>
  readOnly?: boolean
}

export default function PhoneNumberInput<Values extends PhoneNumberValues>({
  form,
  readOnly,
  ...props
}: Props<Values> & Omit<NumberInputProps, 'form'>) {
  const isError = !!form.getInputProps('phoneNumber').error || !!form.getInputProps('countryCode').error
  const errorMessage: string = form.getInputProps('phoneNumber').error || form.getInputProps('countryCode').error

  const { error: countryCodeError, ...countryCodeInputProps } = form.getInputProps('countryCode')
  const { error: phoneNumberError, ...phoneNumberInputProps } = form.getInputProps('phoneNumber')

  return (
    <NumberInput
      label="Numer telefon"
      description="Numer telefonu który będzie przekazywany kurierowi"
      placeholder="123 456 789"
      thousandSeparator=" "
      allowNegative={false}
      allowDecimal={false}
      hideControls
      error={isError ? errorMessage : null}
      readOnly={readOnly}
      leftSection={
        <NumberInput
          placeholder="+00"
          tabIndex={-1}
          prefix="+"
          allowNegative={false}
          allowDecimal={false}
          hideControls
          errorProps={{ style: { display: 'none' } }}
          readOnly={readOnly}
          styles={{
            input: {
              fontWeight: 500,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              borderColor: isError ? 'var(--mantine-color-red-6)' : undefined,
              width: 62,
              marginRight: 9,
              marginTop: isError ? 5 : -5,
            },
          }}
          min={1}
          max={999}
          clampBehavior="strict"
          {...countryCodeInputProps}
        />
      }
      leftSectionWidth={69}
      {...phoneNumberInputProps}
      {...props}
    />
  )
}
